"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineClamp = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
function LineClamp(_a) {
    var children = _a.children, numOfLines = _a.numOfLines;
    return React.createElement(StyledLineClamp, { numOfLines: numOfLines }, children);
}
exports.LineClamp = LineClamp;
var StyledLineClamp = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n"], ["\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n"])), function (_a) {
    var numOfLines = _a.numOfLines;
    return (numOfLines ? "".concat(numOfLines) : 'none');
});
var templateObject_1;
//# sourceMappingURL=index.js.map